module.exports = {
	"library.navbar.sign_up": "Registreren",
	"library.navbar.sign_in": "Inloggen",
	"library.navbar.sign_out": "Uitloggen",
	"library.navbar.help": "Help",
	"library.navbar.search_for_events": "Zoek evenementen",
	"library.navbar.enter_location": "Voer locatie in",
	"library.navbar.find_events": "Zoek evenementen",
	"library.navbar.create_event": "Maak evenement aan",
	"library.navbar.host_events": "Organiseer een evenement",
	"library.navbar.dashboard": "Dashboard",
	"library.navbar.my_events": "Mijn evenementen",
	"library.navbar.my_tickets": "Mijn Tickets",
	"library.navbar.admin_panel": "Admin-panel",
	"library.navbar.profile": "Profiel",
	"library.navbar.messages": "Berichten",
	"library.navbar.settings": "Instellingen",
	"library.navbar.search_cities": "Zoek op steden",
	"library.navbar.help_center": "Helpcentrum",
	"library.navbar.cant_find_tickets": "Waar zijn mijn tickets?",
	"library.navbar.contact_organizer": "Contact met de organisator",
	"library.navbar.can_refund": "Kan ik een vergoeding krijgen?"
};


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/translations/nl.json
// module id = 1518
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16